import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Zoom from 'react-reveal/Zoom';
import Willam from "../../../../src/docs/assets/willam.jpg";
import Pyotr from "../../../../src/docs/assets/pyotr.jpg";
import Smuin from "../../../../src/docs/assets/profiles/smuin.jpg";
import Sergei from "../../../../src/docs/assets/profiles/sergei.jpg";
import Heuvel from "../../../../src/docs/assets/profiles/heuvel.jpg";
import French from "../../../../src/docs/assets/profiles/french.jpg";
import Viselli from "../../../../src/docs/assets/profiles/viselli.jpg";
import Rogers from "../../../../src/docs/assets/profiles/rogers.jpg";
import Sellars from "../../../../src/docs/assets/profiles/sellars.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Zoom,
  Willam,
  Pyotr,
  Smuin,
  Sergei,
  Heuvel,
  French,
  Viselli,
  Rogers,
  Sellars,
  React
};